// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentDetailMethod_root_1SoAQ","item":"PaymentDetailMethod_item_2Te0t"};